
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Machine } from '@/services/model/machine'
import { Roles } from '@/services/repository/users'
import { useAppContext } from '@/context/app'
import { DafaultMenu } from './default'
import { CoordinatorMenu } from './coordinator'
import { Spinner } from '@/components/spinner'


export const DashboardMenu = ({ machine }: {
    machine: Machine
}) => {
    const { services, session, translates } = useAppContext()
    const navigate = useNavigate()

    if (session === undefined) {
        return <Spinner />
    }

    switch (session?.user.role) {
        case Roles.Coordinator:
            return <CoordinatorMenu machine={machine} />
        default:
            return <DafaultMenu machine={machine} />
    }
}
